import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-not-closed-route-list',
  templateUrl: './not-closed-route-list.component.html',
  styleUrls: ['./not-closed-route-list.component.scss']
})
export class NotClosedRouteListComponent implements OnInit {
  route_list: any;

  constructor(
    public dialogRef: MatDialogRef<NotClosedRouteListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.route_list = data['route_list'];
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
